import { useMediaQuery } from "@mantine/hooks";
import type { FunctionComponent } from "react";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { matchPath, Outlet, useLocation } from "react-router-dom";

import { BootMark } from "~/components/BootMark.tsx";
import Button from "~/components/buttons/Button/Button";
import MainNavigation from "~/components/MainNavigation/MainNavigation";
import { appRoutes } from "~/constants/appRoutes.ts";

// Only the dashboard and the logout work on a phone. The other pages are not built for a phone.
// The logout stays, because a phone user must still be able to log out.
// The base path stays too: the home screen app opens it, and the blocker would hide the page that redirects it to the dashboard.
const PHONE_ROUTES = [appRoutes.base().path, appRoutes.dashboard().path, appRoutes.logout().path];

// Matches the Tailwind breakpoint `lg`.
const LG_MEDIA_QUERY = "(min-width: 1024px)";

const AppLayoutPlain: FunctionComponent = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	// Read the width at the first render, so a phone never mounts the page before the blocker.
	const isDesktop = useMediaQuery(LG_MEDIA_QUERY, undefined, { getInitialValueInEffect: false });
	const isPhoneRoute = PHONE_ROUTES.some(path => matchPath(path, pathname));
	const showBlocker = !isDesktop && !isPhoneRoute;

	return (
		<div className="font-normal">
			<MainNavigation />
			<main className="lg:pl-64">
				{showBlocker ? (
					<div className="flex flex-col items-center gap-y-4 p-8 text-center">
						<p>{t("phoneBlocker.message")}</p>
						<Button to={appRoutes.dashboard().path}>{t("phoneBlocker.backToDashboard")}</Button>
					</div>
				) : (
					<Suspense fallback={<BootMark />}>
						<Outlet />
					</Suspense>
				)}
			</main>
		</div>
	);
};

export default AppLayoutPlain;
